import '../include/autoHeightAnimateFunction';
import 'jquery-ui/ui/widgets/slider';
import setChangeColorButtonHandler from "../include/setChangeColorButtonHandler";
//import {LoadingRow} from "./loadingRow";

function intFromText(str) {
    return parseInt(str.replace(/[aA-zZ]|\W+/g, ''));
}

function isTradein($obj) {
    return $obj.hasClass('tradein')
}

function isUtil($obj) {
    return $obj.hasClass('util')
}

window.WidgetSkyCreditFormStep = {
    discountCredit: 0,
    discountCreditMod: 30000,
    init: function () {
        this.$creditFormBrand = $('#creditFormBrand');
        //this.$jsChangeColorBrandImage = $('#jsChangeColorBrandImage');
        this.$creditFormCar = $('#creditFormCar');
        this.$creditFormEq = $('#creditFormEq');
        this.$creditFormBrandTitle = $('#creditFormBrandTitle');
        this.$creditFormCarTitle = $('#creditFormCarTitle');

        this.$jsChangeColorImage = $('#jsChangeColorImage');
        this.defaultImage = '/assets/images/img/auto_grey3.png';

        this.$creditFormCarColors = $('#creditFormCarColors');
        this.$creditFormEqTitle = $('#creditFormEqTitle');
        this.$creditFormCarDiscountPrice = $('.creditFormCarDiscountPrice');
        this.$creditFormCarPrice = $('#creditFormCarPrice');
        this.$jsColorName = $('#jsColorName');
        this.$creditFormBank = $('#prioritybank');
        this.$sum_price_new = $('#sum_price_new');
        this.$jsAgreePersent = $('#jsAgreePersent');
        //this.loadingRowStep1 = new LoadingRow('.loading_row.step1');
        //this.loadingRowStep2 = new LoadingRow('.loading_row.step2');
        //this.loadingRowStep3 = new LoadingRow('.loading_row.step3');
        //this.loadingRowStep4 = new LoadingRow('.loading_row.step4');

        this.step1();
        this.step2();
        this.step3();
        this.step4();
        this.agreePersent();
    },
    /** car select */
    step1: function () {
        setChangeColorButtonHandler(
            '#jsChangeColorImage',
            '.jsChangeColorButton',
            '#jsColorName'
        );

        let self = this;
        this.$creditFormBrand.on('change', function () {
            let $option = $('option:selected', this);
            let creditFormBrandId = $option.val();
            
            if ($option.index() > 0)
            {
             $(this).next().addClass('notempty');
            }
            else
             $(this).next().removeClass('notempty');


            if (creditFormBrandId) {
                $.post({
                    url: window.location.href,
                    data: {
                        creditFormBrandId: creditFormBrandId
                    }
                }).then(function (response) {
                    self.$creditFormBrandTitle.text($option.text());
                    //self.$jsChangeColorBrandImage.attr('src', $option.data('image'));
                    self.$creditFormCarTitle.text('');
                    self.$jsChangeColorImage.attr('src', self.defaultImage);
                    self.$creditFormCarColors.html(response.colors);
                    self.$creditFormEqTitle.text('Не выбрана');
                    self.$sum_price_new.text('');
                    self.changePrice('-');
                    self.$jsColorName.text('');
                    //self.$creditFormCarDiscountPrice.text('');
                    self.$creditFormCar.html(response.cars);
                    self.$creditFormEq.html(response.eqs);
                    //self.loadingRowStep1.set(10);
                    //self.loadingRowStep2.set(10);
                });
            }
            else
            {
                    self.$creditFormBrandTitle.text('');
                    //self.$jsChangeColorBrandImage.attr('src', $option.data('image'));
                    self.$creditFormCarTitle.text('');
                    self.$jsChangeColorImage.attr('src', self.defaultImage);
                    self.$creditFormCarColors.html('');
                    self.$creditFormEqTitle.text('Не выбрана');
                    self.$sum_price_new.text('');
                    self.changePrice('-');
                    self.$jsColorName.text('');
                    //self.$creditFormCarDiscountPrice.text('');
                    self.$creditFormCar.html('<option>Модель</option>');
                    self.$creditFormEq.html('<option>Комплектация</option>');
          
            }

            //summary
            $('#sum_brand').text($option.text());
        });

        this.$creditFormCar.on('change', function () {
            let $option = $('option:selected', this);

            if ($option.index() > 0)
            {
             $(this).next().addClass('notempty');
            }
            else
             $(this).next().removeClass('notempty');


            self.$creditFormCarTitle.text($option.text());
            self.changePrice('-');
            //self.$creditFormCarDiscountPrice.text('');
            self.$creditFormEqTitle.text('Не выбрана');
            self.$sum_price_new.text('');
            //self.loadingRowStep1.set(10);
            //self.loadingRowStep2.set(10);

            let imageUrl = $option.data('image');
            imageUrl ? self.$jsChangeColorImage.attr('src', imageUrl) : self.$jsChangeColorImage.attr('src', '/assets/images/img/auto_grey3.png');
            let colorName = $option.data('colorname');
            colorName ? self.$jsColorName.text(colorName) : 0;


            self.discountCredit = $option.data('new_discount_credit');


            let creditFormCarId = $option.val();
            if (creditFormCarId) {
                $.post({
                    url: window.location.href,
                    data: {
                        creditFormCarId: creditFormCarId
                    }
                }).then(function (response) {
                    self.$creditFormCarColors.html(response.colors);
                    self.$creditFormEq.html(response.eqs);
                });
            }
            //summary
            $('#sum_model').text($option.text());

        });

        this.$creditFormEq.on('change', function () {
            let $option = $('option:selected', this);
 
            if ($option.index() > 0)
            {
             $(this).next().addClass('notempty');
            }
            else
             $(this).next().removeClass('notempty');
           
            
            self.$creditFormEqTitle.text($option.data('title'));
            self.changePrice($option.data('discount_price'));
            self.$creditFormCarPrice.text($option.data('discount_price'));
            $("#summa_credita .content").text($option.data('discount_price'));
            
            
            //$option.data('max_discount')
            //self.loadingRowStep1.set(20);
            //self.loadingRowStep2.set(60);
            //summary
            let discountPrice = intFromText($option.data('discount_price'));
            let persent = parseInt((discountPrice / 100) * 10);
            
            $('#sum_eq').text($option.text());
            $('#sum_price_old').text($option.data('price'));
            //self.$creditFormCarDiscountPrice.text(`${prettyNumber(discountPrice - persent - self.getYourPriceStep2())} ₽`)
            self.$sum_price_new.text(`${prettyNumber(discountPrice - persent)} ₽`);
            $('#sum_price_sale').text(
                prettyNumber(
                    parseInt($option.data('max_discount'))
                ) + ' ₽'
            );
        });

        this.changePrice = function (price = '') {
            self.$creditFormCarPrice.text(price);
            $("#summa_credita .content").text(price);
            $(document).trigger('creditFormChangePrice', price);
        }
        this.$creditFormBank.on('change', function () {
            let $option = $('option:selected', this);
            $('#sum_bank').text($option.text());
        });
        /** -- */
        if ($('.credit_form_step.step_2').hasClass('inactive')) {
            $('.chance, .js-credit, .ui-input.credit').hide();
        }
        let $step3 = $('.credit_form_step.step_3');


        let $js_util = $('.js-util');
        $js_util.hide();
        if (isUtil($step3)) {
            $step3.hasClass('inactive') ? $js_util.hide() : $js_util.show();
        }
        $(document).on('click', '[data-toggled=1] .creditFormStepTitle', function () {
            let $container = $(this).parents('[data-toggled=1]');
            let isCredit = $container.hasClass('step_2');
            let isTradeinF = isTradein($container);
            let isUtilF = isUtil($container);

            if ($container.hasClass('inactive')) {
                window.autoHeightAnimate($container, 500);
                $container.removeClass('inactive');
                isCredit ? $('.chance, .js-credit, .ui-input.credit').slideDown() : null;
                isTradeinF ? $('.js-tradein').slideDown() : null;
                isUtilF ? $('.js-util').slideDown() : null;
            } else {
                let curHeight = $container.outerHeight();
                $container.removeAttr('style').addClass('inactive');
                let newHeight = $container.outerHeight();
                $container.css({height: curHeight}).animate({height: newHeight}, 500);
                isCredit ? $('.chance, .js-credit, .ui-input.credit').slideUp() : null;
                isTradeinF ? $('.js-tradein').slideUp() : null;
                isUtilF ? $('.js-util').slideUp() : null;
            }
        });
        /** -- */
        /*
        $(window).on("scroll", function () {
            if ($(window).scrollTop() > 140) {
                //$('#creditFormView').addClass('fixed');
            } else {
                //$('#creditFormView').removeClass('fixed');
            }
        });
        */
        $(".clear-credit-filter").on('click', function() {
           $("#creditFormBrand").val('').trigger('change');
           $("#creditFormBrand").next().html( $("#creditFormBrand").find("option:selected").text());
           /*
           
           $("#creditFormCar").val('').trigger('change');;
           $("#creditFormCar").next().html( $("#creditFormCar").find("option:selected").text());
           $("#creditFormEq").val('').trigger('change');;
           $("#creditFormEq").next().html( $("#creditFormEq").find("option:selected").text());*/
           
           return false;
              
        });
    },
    /** credit */
    step2: function () {
        let self = this;


        $('#creditingPeriod').slider({
            min: 0,
            max: 96,
            step: 6,
            value: 6,
            range: "min",
            create: function () {
                $('#creditingPeriodValue').val(
                    $(this).slider("value")
                    + ` месяцев`
                );
                $('#srok_credita .content').val(
                    $(this).slider("value")
                    + ` месяцев`
                );
                
                $('#creditingPeriodDisplayValue').html(
                    ($(this).slider("value")/12) + ' года (' + $(this).slider("value")
                    + ` месяцев)`
                );
            },
            change: function (event, ui) {
                let val = parseInt(ui.value);
                let text = ['месяц', 'месяца', 'месяцев'];
                let text_years = ['год', 'года', 'лет'];
                
                
                if (ui.value == 0)
                {
                 return false;
                }
                let index = window.getRuPluralIndex(val);
                
                let years = ui.value / 12;
                let year_index = window.getRuPluralIndex(years);
                if (years == 1.5 || years == 0.5)
                 year_index = 1; 
                
                $('#creditingPeriodValue').val(`${ui.value} ${text[index]}`);
                $('#creditingPeriodDisplayValue').html(`${years} ${text_years[year_index]} (${ui.value} ${text[index]})`);
                $("#srok_credita .content").html(`${ui.value} ${text[index]}`);
                $('#sum_mounth').text(`${ui.value} ${text[index]}`);
            }
        });
        $("#creditingPeriodSelect").change(function() {
            $('#creditingPeriod').slider("value", $(this).val());           
        });

        let updatePriceFlag = false;
        let updatePrice = function (sliderValue) {
            let $sum_price_sale = $('#sum_price_sale');
            let CDP = intFromText(self.$creditFormCarPrice.text());
            let SPS = intFromText(self.$sum_price_new.text());

            if (isNaN(CDP) || isNaN(SPS)) {
                return;
            }

            if (sliderValue === 0) {
                CDP += self.discountCreditMod;
                SPS -= self.discountCreditMod;
                updatePriceFlag = true;
            } else if (sliderValue === 10 && updatePriceFlag) {
                CDP -= self.discountCreditMod;
                SPS += self.discountCreditMod;
                updatePriceFlag = false;
            }


            $sum_price_sale.text(`${prettyNumber(SPS)} ₽`);
            self.$sum_price_new.text(`${prettyNumber(CDP)} ₽`);
        }

        $('#anInitialFee').slider({
            min: 0,
            max: 70,
            range: "min",            
            step: 0.000000000000001,
            value: 0,
            create: function () {
                $('#anInitialFeeValue').val($(this).slider("value"));
                $('#anInitialFeeDisplayValue').html( '' );
                
            },
            slide: function (event, ui) {
                /*$(this).slider("value", $(this).val());*/
            },
            change: function (event, ui) {
                updatePrice(ui.value);
                if (ui.value === 0) {
                    //self.loadingRowStep2.set(50);
                } else if (ui.value === 10) {
                    //self.loadingRowStep2.set(60);
                } else {
                    //self.loadingRowStep2.set(70);
                }
                let price = intFromText(self.$creditFormCarPrice.text());
                if (price) {
                    let persent = parseInt((price / 100) * ui.value);
                    //self.$creditFormCarDiscountPrice.text(`${window.prettyNumber(price - persent - self.getYourPriceStep2())} ₽`)
                    $('#anInitialFeeValue').val(`${window.prettyNumber(persent)} ₽`);
                    $('#anInitialFeeDisplayValue').html( Math.ceil(ui.value) + `% (${window.prettyNumber(persent)} ₽)`);
                    $('#pervy_vznos .content').html(`${window.prettyNumber(persent)} ₽`);
                    
                    //$('#sum_percent').text(`${window.prettyNumber(persent)} ₽`);
                    $("#pervy_vznos .content").html(`${window.prettyNumber(persent)} ₽`);
                    //self.$sum_price_new.text(`${prettyNumber(price - persent)} ₽`);
                }

                setTimeout(function () {
                    $(document).trigger('creditFormAgree');
                }, 0);
            }
            
            
            
        });
        $("#anInitialFeeSelect").change(function() {
            $('#anInitialFee').slider("value", $(this).val());           
        });

        $(document).on('creditFormChangePrice', function (e, price) {
            let sliderValue;
            let FeeValue;
            if (price) {
                price = intFromText(price);
                sliderValue = 10;
                FeeValue = prettyNumber(parseInt((price / 100) * sliderValue));
            } else {
                FeeValue = 0;
                sliderValue = 0;
            }
            if (price) {
                $('#anInitialFeeDisplayValue').html(  Math.ceil(sliderValue) +  `% (${FeeValue} ₽)`);
                $("#pervy_vznos .content").html(`${FeeValue} ₽`);
            }
            else
            {
                $('#anInitialFeeDisplayValue').html(  Math.ceil(sliderValue) +  `%`);
                $("#pervy_vznos .content").html(`-`); 
            }
            $('#anInitialFeeValue').val(`${FeeValue} ₽`);
            
            //$('#sum_percent').text(`${FeeValue} ₽`);
            //$("#pervy_vznos .content").html(`${FeeValue} ₽`);
            $('#anInitialFee').slider("value", sliderValue);
            $(document).trigger('creditFormAgree');
        });

        $('#anInitialFeeValue').on('focusout keyup', function (e) {
            let enterKeyCode = 13;
            if (e.type === "keyup" && e.keyCode !== enterKeyCode) {
                return;
            }
            let price = intFromText(self.$creditFormCarPrice.text());
            if (price) {
                let inputValue = intFromText($(this).val());
                let persent = (inputValue * 100) / price;
                if (persent > 70) {
                    persent = 70;
                    $(this).val(`${prettyNumber((price / 100) * 70)} ₽`);
                } else {
                    $(this).val(`${prettyNumber(inputValue)} ₽`);
                }
                let $anInitialFee = $('#anInitialFee');
                $anInitialFee.slider("value", persent);
                $anInitialFee.slider('option', 'slide').call({}, {}, {value: persent});
            }
        });
    },
    /** tradein */
    step3: function () {
        $('#utilSert').on('change', function () {
            $('#jsInputWrap').toggle();
            $('#jsInputWrap input').val('').trigger('keyup');
        });

        let savedText1 = $('#js-tradein-car').text();
        $('#jsTradeinModel').on('keyup', function () {
            let $self = $(this);
            let $text = $('#js-tradein-car');

            if ($self.val().trim().length) {
                $text.text($self.val());
            } else {
                $text.text(savedText1);
            }
        });

        let savedText2 = $('#js-auto-rate').text();
        $('#jsTradeinYourPrice').on('keyup', function () {
            let $self = $(this);
            let $text = $('#js-auto-rate');

            if ($self.val().trim().length) {
                $text.text(`${prettyNumber($self.val())} ₽`);
            } else {
                $text.text(savedText2);
            }
            let $anInitialFee = $('#anInitialFee');
            $anInitialFee.slider('option', 'slide').call({}, {}, {value: $anInitialFee.slider("value")});
        });
    },
    /** form */
    step4: function () {
        window.formComponent.forms.creditFormId = {
            injectData: function (context) {
                //model step
                let brand = $('#creditFormBrand option:selected').text();
                let modelt = $('#creditFormCar option:selected').text();
                let equipmentt = $('#creditFormEq option:selected').text();
                let type = context.data.get('Tickets[other][radio]');

                let model = $('#creditFormCar option:selected').val();
                let equipment = $('#creditFormEq option:selected').val();
                //credit
                let $prioritybankOption = $('#prioritybank option:selected');
                let bank = $prioritybankOption.val();
                bank = bank ? $prioritybankOption.text() : '';
                let credit_period = $('#creditingPeriodValue').val();
                let anInitial_fee = $('#anInitialFeeValue').val();
                let comment = `Тип: ${type}. Бренд: ${brand}. Модель: ${modelt}. Комплектация: ${equipmentt}. 
                Срок кредита: ${credit_period}. Первоначальный взнос: ${anInitial_fee}. Банк: ${bank}`;
                    comment = comment.replace(/(\n|\t)/g,'');
                    comment = comment.replace(/\s+/g,' ');
                //tradein step
                let tradein_model = $('[name=tradein_model]').val();
                let tradein_year = $('[name=tradein_year]').val();
                let tradein_kpp = $('[name=tradein_kpp]').val();
                let tradein_price = $('[name=tradein_price]').val();
                let tradein_toggle = '0';
                let tradein_info = '';
                if (tradein_model || tradein_year || tradein_kpp || tradein_price) {
                    tradein_toggle = '1';
                    tradein_info = `Модель: ${tradein_model} ,Год: ${tradein_year},Кпп: ${tradein_kpp},Ваша цена: ${tradein_price}`;
                }


                let data = {
                    'Tickets[other][model]': model,
                    'Tickets[other][equipment]': equipment,
                    'Tickets[other][ttype]': true, //is credit flag
                    'Tickets[other][tradein_toggle]': tradein_toggle,
                    'Tickets[other][tradeininfo]': tradein_info,
                    'Tickets[other][comment]': comment
                }

                for (let key in data) {
                    context.data.set(key, data[key]);
                }
            },
            onAjaxComplete: function (context) {
                window.formComponent.onAjaxComplete(context);
                $('.link-to-btn').text('рассматривается');
            }
        };
        $(".link-to-btn").on('click', function () {
            $('.step_4 button').addClass('bloom-bloom');
            setTimeout(function () {
                $('.step_4 button').removeClass('bloom-bloom');
            }, 400)
        });
    },
    agreePersent: function () {
    
        return true;
    },
    getYourPriceStep2: function () {
        let $input = $('#jsTradeinYourPrice');
        if ($input.length && $input.val()) {
            return intFromText($input.val());
        }
        return 0;

    }
    
}


